import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import toastError from "../../components/notif";
import { api } from "./index.api";
import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Quize } from "../../types/quize";

function quizeApiErrorHandler(error: FetchBaseQueryError) {
  switch (error.status) {
    default:
      toastError("unkown error please try again later");
  }
}

const quizeEntity = createEntityAdapter<Quize, string>({
  selectId: (quize: Quize) => quize._id,
});

const QuizeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCourseQuizes: builder.query<
      EntityState<Quize, string>,
      {
        courseId: string;
      }
    >({
      query: (input) => `/courses/${input.courseId}/quizes`,
      transformResponse(baseQueryReturnValue, meta, arg) {
        return quizeEntity.addMany(
          quizeEntity.getInitialState(),
          baseQueryReturnValue as any
        );
      },
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          quizeApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      providesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "quizes",
            id: api.courseId,
          },
        ];
      },
    }),
    addQuize: builder.mutation<
      void,
      { courseId: string; data: Omit<Quize, "_id" | "course" | "questions"> }
    >({
      query: (input) => ({
        url: `/admin/courses/${input.courseId}/quizes`,
        method: "POST",
        body: input.data,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          quizeApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "quizes",
            id: api.courseId,
          },
        ];
      },
    }),
    updateQuize: builder.mutation<
      void,
      {
        courseId: string;
        quizeId: string;
        data: Partial<Omit<Quize, "_id" | "course" | "questions">>;
      }
    >({
      query: (input) => ({
        url: `/admin/quizes/${input.quizeId}`,
        method: "PUT",
        body: input.data,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          quizeApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "quizes",
            id: api.courseId,
          },
        ];
      },
    }),
    deleteQuize: builder.mutation<
      void,
      {
        courseId: string;
        quizeId: string;
      }
    >({
      query: (input) => ({
        url: `/admin/quizes/${input.quizeId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          quizeApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "quizes",
            id: api.courseId,
          },
        ];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCourseQuizesQuery,
  useAddQuizeMutation,
  useUpdateQuizeMutation,
  useDeleteQuizeMutation,
} = QuizeApi;
